import type { ReactNode } from "react";
import AuthControls from "../Components/AuthControls";

export default function MainLayout({ children }: { children: ReactNode }) {
    return (
        <div className="flex min-h-screen flex-col bg-white dark:bg-gray-900">
            <header className="border-b border-gray-100 dark:border-gray-800">
                <div className="mx-auto flex max-w-2xl items-center justify-between gap-2 px-4 py-4 sm:px-6">
                    <div className="flex items-center gap-2">
                        <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-brand-600 text-white">
                            <svg
                                aria-hidden="true"
                                className="h-5 w-5"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                                strokeWidth={2}
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m6.75 12h-9m9-3.75h-9M6.75 21h10.5a2.25 2.25 0 002.25-2.25V6.621a4.5 4.5 0 00-1.318-3.182l-2.121-2.121A4.5 4.5 0 0013.379.75H6.75A2.25 2.25 0 004.5 3v15.75A2.25 2.25 0 006.75 21z"
                                />
                            </svg>
                        </span>
                        <div>
                            <p className="text-sm font-bold leading-tight text-gray-900 dark:text-gray-100">
                                PDF Reader
                            </p>
                            <p className="text-xs leading-tight text-gray-500 dark:text-gray-400">
                                Da PDF a Markdown
                            </p>
                        </div>
                    </div>
                    <AuthControls />
                </div>
            </header>

            <main className="mx-auto w-full max-w-2xl flex-1 px-4 py-6 sm:px-6">{children}</main>

            <footer className="border-t border-gray-100 px-4 py-4 text-center text-xs text-gray-400 dark:border-gray-800 sm:px-6">
                &copy; {new Date().getFullYear()} PDF Reader
            </footer>
        </div>
    );
}
